import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import Avatar from '~/client/components/Avatar'
import AppIcon from '~/client/components/AppIcon'
import datapalLogoMarkWhiteRgb from '~/client/media/logo/datapal-logo-mark-white-rgb.svg'
import datapalAppIconFullColorRgb from '~/client/media/logo/datapal-app-icon-full-color-rgb.b19e7c3d.svg'

export default function Page() {
  const apps = [
    {name: 'Data Pal', logo: datapalLogoMarkWhiteRgb},
    {name: 'Data Pal', logo: datapalAppIconFullColorRgb},
    {name: 'Pizza Gate'},
    {name: 'GitHub', logo: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Flogos-download.com%2Fwp-content%2Fuploads%2F2016%2F09%2FGitHub_logo.png&f=1&nofb=1&ipt=0ae1d9fa02ef1cd5a38a3b3c2866da1fd1407b915aaa539a6d8328d02c6f6c3c&ipo=images'},
  ]
  return <div>
    {apps.map(app =>
      <Stack direction="row" alignItems="center">
        {Object.keys(Avatar.SIZES).map(size =>
          <Box sx={{m: 1}}><AppIcon size={size} app={app}/></Box>
        )}
      </Stack>
    )}
  </div>
}
